export default "__VITE_ASSET__CDJmM8Bu__"